import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";

import { datetime } from "@/utils/time";
import { Mixins, Component, Inject } from "vue-property-decorator";
import { INotification } from "../../types";
import VEmptyState from "@/vuetify-extensions/VEmptyState.vue";
import NetworkErrorImage from "@/components/NetworkErrorImage.vue";
import NotificationsClient from "../../services/NotificationsClient";
import { EServices } from "@/types";

@Component({
  components: {
    VEmptyState,
    NetworkErrorImage,
  },
})
export default class Notifications extends Mixins(
  JackocoinsNetworkManagerMixin
) {
  @Inject(EServices.notifications)
  notificationsClient!: NotificationsClient;

  refreshing = false;

  notifications: INotification[] = [];

  datetime = datetime;

  @throwsNetworkError()
  async getNotifications() {
    this.notifications = await this.notificationsClient.getNotifcations();
  }

  async refresh() {
    this.refreshing = true;
    await this.getNotifications();
    this.refreshing = false;
  }

  mounted() {
    this.getNotifications();
  }
}
